<template>
  <picture>
    <source
      v-if="modernFormatImage['mobile-path-retina']"
      :srcset="`${modernFormatImage['mobile-path-retina']} 2x`"
      media="(max-width: 600px)"
    />
    <source
      v-if="modernFormatImage['mobile-path']"
      :srcset="modernFormatImage['mobile-path']"
      media="(max-width: 600px)"
    />
    <source
      v-if="fallbackFormatImage['mobile-path-retina']"
      :srcset="`${fallbackFormatImage['mobile-path-retina']} 2x`"
      media="(max-width: 600px)"
    />
    <source
      v-if="fallbackFormatImage['mobile-path']"
      :srcset="fallbackFormatImage['mobile-path']"
      media="(max-width: 600px)"
    />
    <source
      v-if="modernFormatImage['tablet-path-retina']"
      :srcset="`${modernFormatImage['tablet-path-retina']} 2x`"
      media="(max-width: 1201px)"
    />
    <source
      v-if="modernFormatImage['tablet-path']"
      :srcset="modernFormatImage['tablet-path']"
      media="(max-width: 1201px)"
    />
    <source
      v-if="fallbackFormatImage['tablet-path-retina']"
      :srcset="`${fallbackFormatImage['tablet-path-retina']} 2x`"
      media="(max-width: 1201px)"
    />
    <source
      v-if="fallbackFormatImage['tablet-path']"
      :srcset="fallbackFormatImage['tablet-path']"
      media="(max-width: 1201px)"
    />
    <source
      v-if="modernFormatImage['desktop-path-retina']"
      :srcset="`${modernFormatImage['desktop-path-retina']} 2x`"
    />
    <source
      v-if="modernFormatImage['desktop-path']"
      :srcset="modernFormatImage['desktop-path']"
    />
    <source
      v-if="fallbackFormatImage['desktop-path-retina']"
      :srcset="`${fallbackFormatImage['desktop-path-retina']} 2x`"
    />
    <img
      :src="fallbackFormatImage['desktop-path']"
      :alt="alt"
      :width="width"
      :height="height"
      :loading="loading"
      decoding="async"
      :fetchpriority="fetchpriority"
    />
  </picture>
</template>

<script setup lang="ts">
import { IPicture } from "~/types/picture.interface";

withDefaults(defineProps<IPicture>(), {
  alt: "",
});
</script>
